import { AxiosApiRequestService } from './http/api-request.service'
import type { ApiRequestService } from '@coris-ts/repository/data-source/api-request.service'
import { Cached } from '@coris-ts/helpers/utilities'
import axios from '../shared/services/axios.interceptor'
import { type AuthComponent, AuthDefaultModule } from './auth/auth.component'
import { type RevenueComponent, RevenueDefaultModule } from './revenue/revenue.component'
import { type EngagementComponent, EngagementDefaultModule } from './engagement/engagement.component'
import { type DashboardComponent, DashboardDefaultModule } from './dashboard/dashboard.component'
import { type SubscribersComponent, SubscribersDefaultModule } from './subscribers/subscribers.component'
import { type ReportsComponent, ReportsDefaultModule } from './reports/reports.component'
import { type ModerationComponent, ModerationDefaultModule } from './moderation/moderation.component'
import {
  type KeywordFlaggingComponent,
  KeywordFlaggingDefaultModule
} from './keyword-flagging/keyword-flagging.component'
import { type PollsComponent, PollsDefaultModule } from './polls/polls.component'
import { organizationSlug } from '../shared/providers/user-provider'

export interface MainComponent {
  getAuthComponent: () => AuthComponent
  getRevenueComponent: () => RevenueComponent
  getEngagementComponent: () => EngagementComponent
  getDashboardComponent: () => DashboardComponent
  getSubscribersComponent: () => SubscribersComponent
  getReportsComponent: () => ReportsComponent
  getModerationComponent: () => ModerationComponent
  getKeywordFlaggingComponent: () => KeywordFlaggingComponent
  getPollsComponent: () => PollsComponent
}

class MainDefaultModule implements MainComponent {
  private readonly apiRequestService: ApiRequestService

  constructor() {
    this.apiRequestService = new AxiosApiRequestService(import.meta.env.VITE_API_URL, axios)
  }

  @Cached()
  public getAuthComponent(): AuthComponent {
    return new AuthDefaultModule()
  }

  @Cached()
  public getRevenueComponent(): RevenueComponent {
    return new RevenueDefaultModule(this.apiRequestService)
  }

  @Cached()
  public getEngagementComponent(): EngagementComponent {
    return new EngagementDefaultModule(this.apiRequestService)
  }

  @Cached()
  public getDashboardComponent(): DashboardComponent {
    return new DashboardDefaultModule(this.apiRequestService)
  }

  @Cached()
  public getSubscribersComponent(): SubscribersComponent {
    return new SubscribersDefaultModule(this.apiRequestService)
  }

  @Cached()
  public getReportsComponent(): ReportsComponent {
    return new ReportsDefaultModule(import.meta.env.VITE_API_URL, axios)
  }

  @Cached()
  public getModerationComponent(): ModerationComponent {
    return new ModerationDefaultModule(import.meta.env.VITE_BACKEND_V2_URL, axios, organizationSlug)
  }

  @Cached()
  public getKeywordFlaggingComponent(): KeywordFlaggingComponent {
    return new KeywordFlaggingDefaultModule(import.meta.env.VITE_BACKEND_V2_URL, axios, organizationSlug)
  }

  @Cached()
  public getPollsComponent(): PollsComponent {
    return new PollsDefaultModule(import.meta.env.VITE_BACKEND_V2_URL, axios, organizationSlug)
  }
}

export const MainModule = new MainDefaultModule()
